export const apiBaseUrl = "https://codebyced.onrender.com";

// Helper function to get the full API URL
export const getApiUrl = (path) => `${apiBaseUrl}/api${path}`;
